/**
 * Parse a YYYY-MM-DD date string as local time (not UTC).
 * Prevents the "date minus one day" bug caused by JS interpreting
 * date-only strings as UTC midnight, which shifts back in western timezones.
 *
 * @param {string} dateStr - Date string in YYYY-MM-DD or ISO format
 * @returns {Date} Date object in local time
 */
export function parseLocalDate(dateStr) {
  if (!dateStr) return new Date(NaN);
  // If it's a plain YYYY-MM-DD string, split and construct as local
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  // For ISO strings with time component, parse normally
  return new Date(dateStr);
}
